import React from "react";

export default function CreditCard(props: any) {
  return (
    <svg version="1.1" id="ico_activities" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24" {...props}>
      <path id="Path_793" fill="none" d="M0,0h24v24H0V0z"/>
      <path fill="currentColor" d="M18,4H6C3.8,4,2,5.8,2,8v8c0,2.2,1.8,4,4,4h12c2.2,0,4-1.8,4-4V8C22,5.8,20.2,4,18,4z M6,6h12c1.1,0,2,0.9,2,2v1H4V8C4,6.9,4.9,6,6,6z M18,18H6c-1.1,0-2-0.9-2-2v-5h16v5C20,17.1,19.1,18,18,18z"/>
   </svg>
  );
}